var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c("ac-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.items,
          "item-class": _vm.row_class,
          "item-key": "uid",
          "fixed-header": "",
          "footer-props": _vm.footer,
          "items-per-page": 50,
          height: _vm.winsize.height - 192,
          search: _vm.search,
          "can-select": (item) => !_vm.row_readonly(item),
          "can-delete": (item) => !_vm.row_readonly(item),
          "remove-bulk": _vm.bulkRemove,
          "bulk-mode": _vm.bulkMode,
          title: "Leaderboard Config",
        },
        on: {
          "update:search": function ($event) {
            _vm.search = $event
          },
          "update:bulkMode": function ($event) {
            _vm.bulkMode = $event
          },
          "update:bulk-mode": function ($event) {
            _vm.bulkMode = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "ma-2",
                    attrs: { color: "primary" },
                    on: { click: _vm.row_create },
                  },
                  [_vm._v(" New Config ")]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "ma-2",
                    attrs: { color: "accent" },
                    on: { click: _vm.show_preview },
                  },
                  [_vm._v(" Preview JSON ")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "item.enabled",
            fn: function ({ item }) {
              return [
                _c("div", { attrs: { align: "center" } }, [
                  _vm._v(_vm._s(item.enabled ? "ON" : "OFF")),
                ]),
              ]
            },
          },
          {
            key: "item.actions",
            fn: function ({ item }) {
              return [
                _vm.row_readonly(item)
                  ? _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { small: "", color: "green" },
                        on: {
                          click: function ($event) {
                            return _vm.row_view(item)
                          },
                        },
                      },
                      [_vm._v(" mdi-eye ")]
                    )
                  : item.locked
                  ? _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { small: "", color: "orange" },
                        on: {
                          click: function ($event) {
                            return _vm.row_update(item)
                          },
                        },
                      },
                      [_vm._v(" mdi-pencil ")]
                    )
                  : _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { small: "", color: "green" },
                        on: {
                          click: function ($event) {
                            return _vm.row_update(item)
                          },
                        },
                      },
                      [_vm._v(" mdi-pencil ")]
                    ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "", color: "teal lighten-1" },
                    on: {
                      click: function ($event) {
                        return _vm.row_copy(item)
                      },
                    },
                  },
                  [_vm._v(" mdi-content-copy ")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: {
                      disabled: item.global || item.shared,
                      small: "",
                      color: "blue",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.row_export(item)
                      },
                    },
                  },
                  [_vm._v("mdi-briefcase-upload")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: {
                      disabled: _vm.row_readonly(item),
                      small: "",
                      color: "red",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.row_remove(item)
                      },
                    },
                  },
                  [_vm._v(" mdi-delete ")]
                ),
              ]
            },
          },
          {
            key: "no-results",
            fn: function () {
              return [
                _c(
                  "v-alert",
                  { attrs: { value: true, color: "blue-grey", dense: "" } },
                  [
                    _vm._v(
                      ' Your search for "' +
                        _vm._s(_vm.search) +
                        '" found no results. '
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _c("r-league-config-dialog", { ref: "dialog" }),
      _c("r-dialog-preview-collection", { ref: "previewCollection" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }